import { GradientMode } from "./GradientMode";
import { Vector4 } from "./Vector4";
export class Gradient {
    get maxColorRGBKeysCount() {
        return this._maxColorRGBKeysCount;
    }
    get colorRGBKeysCount() {
        return this._colorRGBKeysCount;
    }
    get _rgbElements() {
        return this._rgbElementDatas;
    }
    set _rgbElements(value) {
        this._rgbElementDatas = value;
        this._maxColorRGBKeysCount = value ? value.length / 4 : 0;
    }
    get maxColorAlphaKeysCount() {
        return this._maxColorAlphaKeysCount;
    }
    get colorAlphaKeysCount() {
        return this._colorAlphaKeysCount;
    }
    get _alphaElements() {
        return this._alphaElementDatas;
    }
    set _alphaElements(value) {
        this._alphaElementDatas = value;
        this._maxColorAlphaKeysCount = value ? value.length / 2 : 0;
    }
    get maxColorKeysCount() {
        return Math.max(this._maxColorAlphaKeysCount, this._maxColorRGBKeysCount);
    }
    ;
    get mode() {
        return this._mode;
    }
    set mode(value) {
        this._mode = value;
    }
    constructor() {
        this._mode = 0;
        this._maxColorRGBKeysCount = 0;
        this._colorRGBKeysCount = 0;
        this._maxColorAlphaKeysCount = 0;
        this._colorAlphaKeysCount = 0;
        this._keyRanges = new Vector4(1, 0, 1, 0);
    }
    addColorRGB(key, value) {
        if (this._colorRGBKeysCount >= this._maxColorRGBKeysCount) {
            let newRGBElementDatas = new Float32Array((this._maxColorRGBKeysCount + 4) * 4);
            this._rgbElementDatas && newRGBElementDatas.set(this._rgbElementDatas);
            this._rgbElements = newRGBElementDatas;
        }
        let offset = this._colorRGBKeysCount * 4;
        this._rgbElementDatas[offset] = key;
        this._rgbElementDatas[offset + 1] = value.r;
        this._rgbElementDatas[offset + 2] = value.g;
        this._rgbElementDatas[offset + 3] = value.b;
        this._colorRGBKeysCount++;
    }
    addColorAlpha(key, value) {
        if (this._colorAlphaKeysCount >= this._maxColorAlphaKeysCount) {
            let newAlphaElementDatas = new Float32Array((this._maxColorAlphaKeysCount + 4) * 2);
            this._alphaElementDatas && newAlphaElementDatas.set(this._alphaElementDatas);
            this._alphaElements = newAlphaElementDatas;
        }
        let offset = this._colorAlphaKeysCount * 2;
        this._alphaElementDatas[offset] = key;
        this._alphaElementDatas[offset + 1] = value;
        this._colorAlphaKeysCount++;
    }
    updateColorRGB(index, key, value) {
        if (index < this._colorRGBKeysCount) {
            var offset = index * 4;
            this._rgbElements[offset] = key;
            this._rgbElements[offset + 1] = value.r;
            this._rgbElements[offset + 2] = value.g;
            this._rgbElements[offset + 3] = value.b;
            if (this._gpuRGBData4 && index < 4) {
                this._gpuRGBData4[offset] = key;
                this._gpuRGBData4[offset + 1] = value.r;
                this._gpuRGBData4[offset + 2] = value.g;
                this._gpuRGBData4[offset + 3] = value.b;
            }
            if (this._gpuRGBData8 && index < 8) {
                this._gpuRGBData8[offset] = key;
                this._gpuRGBData8[offset + 1] = value.r;
                this._gpuRGBData8[offset + 2] = value.g;
                this._gpuRGBData8[offset + 3] = value.b;
            }
        }
        else {
            console.warn("Gradient:warning:index must lessEqual than colorRGBKeysCount:" + this._colorRGBKeysCount);
        }
    }
    updateColorAlpha(index, key, value) {
        if (index < this._colorAlphaKeysCount) {
            var offset = index * 2;
            this._alphaElements[offset] = key;
            this._alphaElements[offset + 1] = value;
            if (this._gpuAlphaData4 && index < 4) {
                this._gpuAlphaData4[offset] = key;
                this._gpuAlphaData4[offset + 1] = value;
            }
            if (this._gpuAlphaData8 && index < 8) {
                this._gpuAlphaData8[offset] = key;
                this._gpuAlphaData8[offset + 1] = value;
            }
        }
        else {
            console.warn("Gradient:warning:index must lessEqual than colorAlphaKeysCount:" + this._colorAlphaKeysCount);
        }
    }
    evaluateColorRGB(lerpFactor, out, startSearchIndex = 0, reverseSearch = false) {
        lerpFactor = Math.min(Math.max(lerpFactor, 0.0), 1.0);
        var rgbElements = this._rgbElements;
        var curIndex = startSearchIndex;
        if (reverseSearch) {
            for (var i = curIndex; i >= 0; i--) {
                var offset = i * 4;
                var left = rgbElements[offset];
                if (lerpFactor === left) {
                    out.r = rgbElements[offset + 1];
                    out.g = rgbElements[offset + 2];
                    out.b = rgbElements[offset + 3];
                    return curIndex;
                }
                var right = rgbElements[offset + 4];
                switch (this._mode) {
                    case GradientMode.Blend:
                        if (lerpFactor > left && right) {
                            if (lerpFactor > right)
                                continue;
                            var diff = right - left;
                            var y1 = right - lerpFactor;
                            var y2 = lerpFactor - left;
                            out.r = (y1 * rgbElements[offset + 1] + y2 * rgbElements[offset + 5]) / diff;
                            out.g = (y1 * rgbElements[offset + 2] + y2 * rgbElements[offset + 6]) / diff;
                            out.b = (y1 * rgbElements[offset + 3] + y2 * rgbElements[offset + 7]) / diff;
                            return curIndex;
                        }
                        else {
                            curIndex--;
                            continue;
                        }
                    case GradientMode.Fixed:
                        if (lerpFactor > left) {
                            if (lerpFactor > rgbElements[offset + 4])
                                throw "Gradient:wrong startSearchIndex.";
                            out.r = rgbElements[offset + 5];
                            out.g = rgbElements[offset + 6];
                            out.b = rgbElements[offset + 7];
                            return curIndex;
                        }
                        else {
                            curIndex--;
                            continue;
                        }
                    default:
                        throw "Gradient:unknown mode.";
                }
            }
        }
        else {
            for (var i = 0, n = this._rgbElements.length; i < n; i++) {
                offset = i * 4;
                var right = rgbElements[offset];
                if (lerpFactor === right) {
                    out.r = rgbElements[offset + 1];
                    out.g = rgbElements[offset + 2];
                    out.b = rgbElements[offset + 3];
                    return curIndex;
                }
                switch (this._mode) {
                    case GradientMode.Blend:
                        if (lerpFactor < right) {
                            var left = rgbElements[offset - 4];
                            if (lerpFactor < left)
                                throw "Gradient:wrong startSearchIndex.";
                            var diff = right - left;
                            var y1 = right - lerpFactor;
                            var y2 = lerpFactor - left;
                            out.r = (y1 * rgbElements[offset - 3] + y2 * rgbElements[offset + 1]) / diff;
                            out.g = (y1 * rgbElements[offset - 2] + y2 * rgbElements[offset + 2]) / diff;
                            out.b = (y1 * rgbElements[offset - 1] + y2 * rgbElements[offset + 3]) / diff;
                            return curIndex;
                        }
                        else {
                            curIndex++;
                            continue;
                        }
                    case GradientMode.Fixed:
                        if (lerpFactor < right) {
                            if (lerpFactor < rgbElements[offset - 4])
                                throw "Gradient:wrong startSearchIndex.";
                            out.r = rgbElements[offset + 1];
                            out.g = rgbElements[offset + 2];
                            out.b = rgbElements[offset + 3];
                            return curIndex;
                        }
                        else {
                            curIndex++;
                            continue;
                        }
                    default:
                        throw "Gradient:unknown mode.";
                }
            }
        }
        return curIndex;
    }
    evaluateColorAlpha(lerpFactor, outColor, startSearchIndex = 0, reverseSearch = false) {
        lerpFactor = Math.min(Math.max(lerpFactor, 0.0), 1.0);
        var alphaElements = this._alphaElements;
        var curIndex = startSearchIndex;
        if (reverseSearch) {
            for (var i = curIndex; i >= 0; i--) {
                var offset = i * 2;
                var left = alphaElements[offset];
                if (lerpFactor === left) {
                    outColor.a = alphaElements[offset + 1];
                    return curIndex;
                }
                var right = alphaElements[offset + 2];
                switch (this._mode) {
                    case GradientMode.Blend:
                        if (lerpFactor > left && right) {
                            if (lerpFactor > right)
                                continue;
                            var diff = right - left;
                            var x1 = right - lerpFactor;
                            var x2 = lerpFactor - left;
                            outColor.a = (x1 * alphaElements[offset + 1] + x2 * alphaElements[offset + 3]) / diff;
                            return curIndex;
                        }
                        else {
                            curIndex--;
                            continue;
                        }
                    case GradientMode.Fixed:
                        if (lerpFactor > left) {
                            if (lerpFactor > alphaElements[offset + 2])
                                throw "Gradient:wrong startSearchIndex.";
                            outColor.a = alphaElements[offset + 3];
                            return curIndex;
                        }
                        else {
                            curIndex--;
                            continue;
                        }
                    default:
                        throw "Gradient:unknown mode.";
                }
            }
        }
        else {
            for (var i = curIndex, n = this._alphaElements.length; i < n; i++) {
                var offset = i * 2;
                var right = alphaElements[offset];
                if (lerpFactor === right) {
                    outColor.a = alphaElements[offset + 1];
                    return curIndex;
                }
                switch (this._mode) {
                    case GradientMode.Blend:
                        if (lerpFactor < right) {
                            var left = alphaElements[offset - 2];
                            if (lerpFactor < left)
                                throw "Gradient:wrong startSearchIndex.";
                            var diff = right - left;
                            var x1 = right - lerpFactor;
                            var x2 = lerpFactor - left;
                            outColor.a = (x1 * alphaElements[offset - 1] + x2 * alphaElements[offset + 1]) / diff;
                            return curIndex;
                        }
                        else {
                            curIndex++;
                            continue;
                        }
                    case GradientMode.Fixed:
                        if (lerpFactor < right) {
                            if (lerpFactor < alphaElements[offset - 2])
                                throw "Gradient:wrong startSearchIndex.";
                            outColor.a = alphaElements[offset + 1];
                            return curIndex;
                        }
                        else {
                            curIndex++;
                            continue;
                        }
                    default:
                        throw "Gradient:unknown mode.";
                }
            }
        }
        return curIndex;
    }
    _updateGpuData(data, elements) {
        let length = Math.min(data.length, elements.length);
        for (let index = 0; index < length; index++) {
            data[index] = elements[index];
        }
    }
    _fixGPUAlphaData(data) {
        if (this.colorAlphaKeysCount == 1) {
            let alpha = this._alphaElements[1];
            data[0] = 0;
            data[1] = alpha;
            data[2] = 1;
            data[3] = alpha;
        }
        else if (this.colorAlphaKeysCount == 2) {
            data[0] = 0;
            data[1] = this._alphaElements[1];
            data[2] = 1;
            data[3] = this._alphaElements[3];
        }
        else {
            this._updateGpuData(data, this._alphaElements);
        }
    }
    _fixGPURGBData(data) {
        if (this.colorRGBKeysCount == 1) {
            let r = this._rgbElements[1];
            let g = this._rgbElements[2];
            let b = this._rgbElements[3];
            data[0] = 0;
            data[1] = r;
            data[2] = g;
            data[3] = b;
            data[4] = 1;
            data[5] = r;
            data[6] = g;
            data[7] = b;
        }
        else if (this.colorRGBKeysCount == 2) {
            data[0] = 0;
            data[1] = this._rgbElements[1];
            data[2] = this._rgbElements[2];
            data[3] = this._rgbElements[3];
            data[4] = 1;
            data[5] = this._rgbElements[5];
            data[6] = this._rgbElements[6];
            data[7] = this._rgbElements[7];
        }
        else {
            this._updateGpuData(data, this._rgbElements);
        }
    }
    _getGPURGBData4() {
        if (!this._gpuRGBData4) {
            this._gpuRGBData4 = new Float32Array(16);
        }
        this._fixGPURGBData(this._gpuRGBData4);
        return this._gpuRGBData4;
    }
    _getGPURGBData8() {
        if (!this._gpuRGBData8) {
            this._gpuRGBData8 = new Float32Array(32);
        }
        this._fixGPURGBData(this._gpuRGBData8);
        return this._gpuRGBData8;
    }
    _getGPUAlphaData4() {
        if (!this._gpuAlphaData4) {
            this._gpuAlphaData4 = new Float32Array(8);
        }
        this._fixGPUAlphaData(this._gpuAlphaData4);
        return this._gpuAlphaData4;
    }
    _getGPUAlphaData8() {
        if (!this._gpuAlphaData8) {
            this._gpuAlphaData8 = new Float32Array(16);
        }
        this._fixGPUAlphaData(this._gpuAlphaData8);
        return this._gpuAlphaData8;
    }
    cloneTo(destObject) {
        destObject._colorAlphaKeysCount = this._colorAlphaKeysCount;
        let destAlphaElements = destObject._alphaElements = new Float32Array(this._alphaElements.length);
        for (let i = 0, n = this._alphaElements.length; i < n; i++)
            destAlphaElements[i] = this._alphaElements[i];
        destObject._colorRGBKeysCount = this._colorRGBKeysCount;
        var destRGBElements = destObject._rgbElements = new Float32Array(this._rgbElements.length);
        for (let i = 0, n = this._rgbElements.length; i < n; i++)
            destRGBElements[i] = this._rgbElements[i];
    }
    clone() {
        var destGradientDataColor = new Gradient();
        this.cloneTo(destGradientDataColor);
        return destGradientDataColor;
    }
}
